// React
import React from 'react';

// utils
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { injectIntl } from 'react-intl';
import messages from 'aurora-translations';
// Components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ADGMImage } from 'aurora-components';
import { PropertyBadge } from 'aurora-section-components';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import { ApplicationStatus } from '../ApplicationDetail/HeaderV2';

const PropertyDetailsHeader = ({ classes, property, lang, intl, showStatus, showPropertyBadge, customStatus }) => {
  const UNIT = property?.propertyType === 4;
  const PLOT = property?.propertyType === 1;
  const ImageSrc = PLOT ? 'land_property.svg' : 'PropertyDetails-Unit.svg';
  const propertiesKeysMap = {
    ar: {
      community: 'communityAr',
      district: 'districtAr',
    },
    en: {
      community: 'communityEn',
      district: 'districtEn',
    },
  };

  const { community, district } = propertiesKeysMap[lang];
  return (
    !isEmpty(property) && (
      <Grid container spacing={2} className={classes.mb}>
        <Grid item>
          <ADGMImage name={ImageSrc} alt={ImageSrc} className={classes.headerImage} />
        </Grid>
        <Grid item>
          <Typography variant='h6' className={classes.title}>
            {UNIT
              ? `${intl.formatMessage({ ...messages.Unit })} ${property?.unitNumber}, ${intl.formatMessage({
                  ...messages.building,
                })} ${property?.buildingNumber}`
              : `${intl.formatMessage({ ...messages.Plot })} ${property?.plotNumber}`}
            <div className={classes.chip}>{keyEmptyCheck(PLOT ? 'Plot' : 'Unit')}</div>
          </Typography>

          <Typography variant='h6'>
            {property?.[community]},{property?.[district]}
          </Typography>
          {showPropertyBadge && (
            <PropertyBadge
              locale={lang}
              property={property}
              isOwnership={false}
              isLease
              expanded={false}
              handleExpand={() => {}}
              classes={{
                badgePill: classes.modifiedBadge,
              }}
            />
          )}
          {showStatus && <ApplicationStatus status={property.status} />}
          {customStatus}
        </Grid>
      </Grid>
    )
  );
};
PropertyDetailsHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  showStatus: PropTypes.bool.isRequired,
  showPropertyBadge: PropTypes.bool.isRequired,
  customStatus: PropTypes.node,
};

PropertyDetailsHeader.defaultProps = {
  customStatus: null,
};

export default withStyles(styles)(injectIntl(PropertyDetailsHeader));
